/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestPatientDataSharingResponseDto
 */
export interface RequestPatientDataSharingResponseDto {
    /**
     * Request ID
     * @type {string}
     * @memberof RequestPatientDataSharingResponseDto
     */
    requestId: string;
    /**
     * Request status
     * @type {string}
     * @memberof RequestPatientDataSharingResponseDto
     */
    status: string;
    /**
     * Message
     * @type {string}
     * @memberof RequestPatientDataSharingResponseDto
     */
    message: string;
}

/**
 * Check if a given object implements the RequestPatientDataSharingResponseDto interface.
 */
export function instanceOfRequestPatientDataSharingResponseDto(value: object): value is RequestPatientDataSharingResponseDto {
    if (!('requestId' in value) || value['requestId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RequestPatientDataSharingResponseDtoFromJSON(json: any): RequestPatientDataSharingResponseDto {
    return RequestPatientDataSharingResponseDtoFromJSONTyped(json, false);
}

export function RequestPatientDataSharingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestPatientDataSharingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'],
        'status': json['status'],
        'message': json['message'],
    };
}

export function RequestPatientDataSharingResponseDtoToJSON(json: any): RequestPatientDataSharingResponseDto {
    return RequestPatientDataSharingResponseDtoToJSONTyped(json, false);
}

export function RequestPatientDataSharingResponseDtoToJSONTyped(value?: RequestPatientDataSharingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
        'status': value['status'],
        'message': value['message'],
    };
}

